/**
 * The viewer's origin, the same value `app/ViewerHost.tsx` points the iframe
 * at. Library assets the VIEWER must fetch itself — iJewel's material files and
 * their textures, whose CDN sends no CORS header — live there, not on ours.
 *
 * `env?.`: the verify scripts import the section modules under plain Node,
 * where `import.meta.env` does not exist.
 */
export const VIEWER_ORIGIN =
  (import.meta.env?.VITE_VIEWER_ORIGIN as string | undefined)?.replace(/\/$/, "") ?? "http://localhost:5174";
